<!--登录页面-->
<template>
  <div class="login" style="background-color: #f8f8f8">
 
    <el-container
      style="
        position: relative;
        width: 1240px;
        height: 100%;
        margin: 20px auto;
        overflow: hidden;
      "
    >
      <div
        id="asideFixedMenu"
        ref="asideFixedMenu"
        class="has-vertical-scrollerbar"
        style="transition: all 0.2s; width: 200px"
      >
        <el-menu
          class=""
          style="border: 0 none; padding-bottom: 80px"
          :collapse="isCollapsed"
          mode="vertical"
          active-text-color="#ffd04b"
          :default-openeds="['1', '2', '3']"
          router
        >
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-user"></i>
              <span slot="title">{{is_danwei==1?'单位中心':'个人中心'}}</span>
            </template>
            <el-menu-item-group>
              <span slot="title">{{is_danwei==1?'单位中心':'个人中心'}}</span>
              <!-- <el-menu-item>个人中心</el-menu-item> -->
              <!-- <el-menu-item>实名认证</el-menu-item> -->
              <el-menu-item index="/updateinfo">资料修改</el-menu-item>
            </el-menu-item-group>
            <!--<el-menu-item-group title="认证">-->
            <!--<el-menu-item index="/seller/list">销售管理</el-menu-item>-->
            <!--</el-menu-item-group>-->
            <el-menu-item-group title="财务">
              <el-menu-item index="/accountmanager">账户管理</el-menu-item>
              <el-menu-item index="/orderlist">订单管理</el-menu-item>
              <el-menu-item index="/payrecords">支付记录</el-menu-item>
              <!--<el-menu-item index="/cashaccount/withdrawList">提现申请</el-menu-item>-->
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2" v-if="false">
            <template slot="title"
              ><i class="el-icon-menu"></i>
              <span slot="title">业务管理</span>
            </template>
            <el-menu-item-group>
              <template slot="title">文件网盘管理</template>
              <el-menu-item index="/openFileApply">
                <el-badge value="艺术导师报名" class="item">
                  文件上传
                </el-badge>
              </el-menu-item>
              <el-menu-item index="/openFileList">文件管理</el-menu-item>

              <el-menu-item index="/kaojiFileApply"> 批量考级 </el-menu-item>
              <el-menu-item index="/kaojiFileList">批量考级管理</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group>
              <template slot="title">投稿</template>
              <el-menu-item index="/tougao">投稿</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group   v-if="is_danwei==1">
              <template slot="title">单位认证</template>
              <!-- <el-menu-item index="/tougao">
                <el-badge value="投稿" class="item">
                投稿
                </el-badge>
              </el-menu-item> -->
              <el-menu-item index="/institutecertificate"
                >单位认证</el-menu-item
              >
            </el-menu-item-group>

            <el-menu-item-group>
              <template slot="title">短视频和微电影剧本大赛</template>
              <el-menu-item index="/videoSaiApply">我要报名</el-menu-item>
              <el-menu-item index="/videoSaiList">报名管理</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-if="is_danwei==2">
              <template slot="title">我的考级</template>
              <el-menu-item index="/kaojiApplyList">考级管理</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-if="is_danwei==1">
              <template slot="title">我的实训</template>
              <el-menu-item index="/shixunApplyList">实训管理</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-if="is_danwei==1">
              <template slot="title">我的研学</template>
              <el-menu-item index="/yanxueApplyList">研学管理</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-if="is_danwei==1">
              <template slot="title">我的国际交流</template>
              <el-menu-item index="/guojiApplyList">国际交流管理</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-if="is_danwei==1">
              <template slot="title">我的竞赛培训</template>
              <el-menu-item index="/saishiApplyList">竞赛培训管理</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-if="is_danwei==2">
              <template slot="title">我的校局长论坛</template>
              <el-menu-item index="/luntanApplyList"
                >校局长论坛管理</el-menu-item
              >
            </el-menu-item-group>
            <el-menu-item-group v-if="is_danwei==1">
              <template slot="title">我的全国艺术节</template>
              <el-menu-item index="/yishujieApplyList"
                >全国艺术节管理</el-menu-item
              >
            </el-menu-item-group>
            <el-menu-item-group v-if="is_danwei==2">
              <template slot="title">我的EAE人才库</template>
              <el-menu-item index="/rencaikuApplyList"
                >EAE人才库管理</el-menu-item
              >
            </el-menu-item-group>

            <el-menu-item-group v-if="is_danwei==2">
              <template slot="title">我的童星库</template>
              <el-menu-item index="/rencaikuApplyList21"
                >童星库管理</el-menu-item
              >
            </el-menu-item-group>
            <el-menu-item-group v-if="is_danwei==2">
              <template slot="title">我的错题</template>
              <el-menu-item index="/wrong-questions">错题集</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group  v-if="is_danwei==1">
              <template slot="title">我的机构申请</template>
              <el-menu-item index="/danweiApplyList">机构管理</el-menu-item>
            </el-menu-item-group>

            <!-- <el-menu-item-group v-show="false">
              <template slot="title">实训体验</template>
              <el-menu-item>报名管理</el-menu-item>
            </el-menu-item-group> -->
            <!-- <el-menu-item-group v-show="false"
              >>
              <template slot="title">我的测试</template>
              <el-menu-item>测试管理</el-menu-item>
              <el-menu-item>课程管理</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-show="false"
              >>
              <template slot="title">竞赛培训</template>
              <el-menu-item>我要报名</el-menu-item>
              <el-menu-item>报名管理</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group v-show="false"
              >>
              <template slot="title">商场</template>
              <el-menu-item>我的收藏</el-menu-item>
              <el-menu-item>商城订单</el-menu-item>
            </el-menu-item-group> -->
          </el-submenu>
        </el-menu>

        <!--                <p class="control-pane"  ><i :class="isCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i></p>-->
      </div>
      <el-container>
        <el-header v-if="false">
          <div :class="['header', { 'has-tabs': meta.tabs }]">
            <div class="content-title">{{ meta.title }}</div>
            <el-tabs v-if="meta.tabs" v-model="activeName">
              <el-tab-pane
                v-for="item in meta.tabs"
                :key="item.pathName"
                :name="item.pathName"
              >
                <router-link
                  tag="span"
                  slot="label"
                  :to="{ name: item.pathName }"
                  >{{ item.label }}
                </router-link>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-header>

        <el-main>
          <keep-alive :include="keepAliveInclude">
            <router-view class="main-content"></router-view>
          </keep-alive>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import HeadNav from "@/components/index/HeadNav";
export default {
  name: "MineLayout",
  components: {
    HeadNav,
  },
  data() {
    return {
      activeIndex: "登录",
      inputusername: "", //用户名
      inputpassword: "", //密码
      inputmobilphone: "", //手机号码
      inputIdecode: "", //验证码
      inputpasswordagain: "", //再次输入密码
      getidecodeData: "获取验证码",
      inputdepartment: "",
      meta: {
        title: "",
        tabs: [],
      },
      keepAlive: true,
      activeName: "",
      keepAliveInclude: this.$route.meta.keepAlive ? this.$route.name : "",
      keepAliveArray: this.$route.meta.keepAlive ? [this.$route.name] : [],

      isCollapsed: false,
      is_danwei: 1, //1单位 2个人
    };
  },
  watch: {
    getidecodeData(newval, oldval) {
      if (newval == 0) {
        this.getidecodeData = "获取验证码";
      }
    },
  },

  created() {},
  mounted() {
    this.getUser();
  },
  methods: {
    getUser() {
      let that = this;
      that.$api.post("/api/index/userdata", {}, (r) => {
        this.is_danwei = r.data.is_danwei;
      });
    },
    handleSelect(val) {
      this.activeIndex = val;
      this.inputusername = "";
      this.inputpassword = "";
      this.inputmobilphone = "";
      this.inputIdecode = "";
      this.inputpasswordagain = "";
      this.inputdepartment = "";
    },
    //登录点击事件
    loginFun() {
      if (
        this.inputusername.trim() == "" ||
        this.inputpassword.trim() == "" ||
        this.inputdepartment.trim() == ""
      ) {
        this.$message({ type: "error", message: "单位/用户名/密码不能为空" });
        this.inputusername = "";
        this.inputpassword = "";
        return;
      }
      //发起请求判断密码账号 是否正确
    },
    //注册点击事件
    registerFun() {
      if (this.inputpasswordagain != this.inputpassword) {
        this.$message({ type: "error", message: "密码确认错误" });
        // this.inputusername="";
        this.inputpassword = "";
        // this.inputdepartment="";
        this.inputpasswordagain = "";
        return;
      }
      if (
        this.inputusername.trim() == "" ||
        this.inputpassword.trim() == "" ||
        this.inputdepartment.trim() == "" ||
        this.inputpasswordagain.trim() == ""
      ) {
        this.$message({ type: "error", message: "内容不能为空" });
        return;
      }
      //发起请求判断
    },
    //获取验证码 点击事件
    getidecodeFun() {
      if (this.getidecodeData == "获取验证码") {
        this.getidecodeData = 59;
        var that = this;
        var timetime;
        timetime = setInterval(function () {
          that.getidecodeData -= 1;
          if (that.getidecodeData <= 0) {
            clearInterval(timetime);
          }
        }, 1000);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// @font-face {
//   /* font-properties */
//   font-family: EuclidFlex-Bold;
//   src: url("~@/assets/font/EuclidFlex-Bold.ttf");
// }
.login {
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  .logincontainer {
    flex: 1;
    position: relative;
    background: #f8f8f8;
    .logincontainerEntureWidth {
      max-width: 1240px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      .bgitem {
        width: 543px;
        height: 569px;
        background: url("~@/assets/images/login/pic-bg.png") center center
          no-repeat;
        position: absolute;
        top: 66px;
        right: 697px;
        background-size: cover;
        -webkit-background-size: cover;
      }
      .logincontainerItem {
        position: absolute;
        right: 0;
        top: 87px;
        width: 452px;
        background: #ffffff;
        box-shadow: 0px 0px 34px 0px rgba(0, 0, 0, 0.05);
        border-radius: 9px;
        padding: 0 13px 0 17px;
        box-sizing: border-box;
        .elmenu {
          margin-bottom: 53px;
        }
        /*公用部分leftLogin/rightRegister*/
        .containerInput {
          margin-top: 24px;
          margin-left: 26px;
          .inputTitle {
            width: 65px;
            height: 14px;
            line-height: 14px;
            display: inline-block;
            /*margin-right: 18px;*/
            line-height: 10px;
            font-size: 16px;

            font-weight: 400;
            color: #000000;
            margin-right: 5px;
          }
        }
        .tipsCommon {
          margin-left: 98px;
          margin-top: 32px;

          cursor: pointer;
        }
        .loginFont {
          width: 95px;
          height: 40px;
          background: #0486fe;
          border-radius: 4px;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          &:hover {
            font-weight: bold;
            opacity: 0.8;
          }
        }
        .forget {
          margin-top: 20px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          margin-bottom: 32px;
          .forgetpassword:hover {
            font-weight: bold;
          }
          .forgetusername:hover {
            font-weight: bold;
          }
        }
        .leftLogin {
          .containerInput {
            .inputTitle {
              width: 65px;
            }
          }
        }
        .rightRegister {
          .containerInput {
            .inputTitle {
              width: 65px;
            }
            .getidecode {
              width: 81px;
              height: 34px;
              text-align: center;
              background: #e6f1fc;
              border-radius: 3px;
              border: 1px solid #a3d0fd;
              font-size: 12px;

              font-weight: 400;
              color: #1989fa;
              line-height: 34px;
              display: inline-block;
              margin-left: 8px;
              &:hover {
                font-weight: bold;
                opacity: 0.8;
                cursor: pointer;
              }
            }
          }
          .loginFont {
            margin-bottom: 32px;
          }
        }
      }
    }
  }
}

.has-vertical-scrollerbar {
  overflow: hidden;
  overflow-y: scroll;
}
.has-vertical-scrollerbar::-webkit-scrollbar-track-piece,
.has-vertical-scrollerbar::-webkit-scrollbar {
  width: 0;
}

.is-active {
  /*font-size:16px;*/
  /*color:#000;*/
  /*font-weight:bold;*/
}
.inputidecode {
  .el-input__inner {
    padding-right: 10px;
  }
}

.main-content {
  position: absolute;
  left: 220px;
  right: 0px;
  top: 0px;
  bottom: 0;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}
.contain_warp {
  width: 1240px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// MineLayout.vue?6b8b5f55